import * as Gui from "../src/Gui.scss";
import { dotsLoading } from "./ViewUtils.js";
import { Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, union_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library.3.7.20/MapUtil.js";
import { tryFind, map as map_1, isEmpty, singleton, empty, ofArray, append } from "./fable_modules/fable-library.3.7.20/List.js";
import { value as value_1, bind, defaultArg, map, toArray } from "./fable_modules/fable-library.3.7.20/Option.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "./fable_modules/fable-library.3.7.20/Seq.js";
import { DOMAttr, HTMLAttr, Prop, CSSProp } from "./fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { FunctionComponent_Of_Z5A158BBF } from "./fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { info } from "./Components/Message/Message.js";
import { Elements_renderCell, Elements_renderHeader } from "./Components/Table/Table.js";
import { uncurry, equals } from "./fable_modules/fable-library.3.7.20/Util.js";


export function LoadState_loadable(state, onOk) {
    switch (state.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return state.fields[0];
        }
        case 2: {
            return onOk(state.fields[0]);
        }
        default: {
            return "";
        }
    }
}

export class MaxWidth extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Xs", "Sm", "Md", "Lg", "Xl", "Fluid"];
    }
}

export function MaxWidth$reflection() {
    return union_type("FenixWeb.Gui.MaxWidth", [], MaxWidth, () => [[], [], [], [], [], []]);
}

function toMaxWidth(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "600px";
        }
        case 2: {
            return "900px";
        }
        case 3: {
            return "1200px";
        }
        case 4: {
            return "1536px";
        }
        case 5: {
            return "100%";
        }
        default: {
            return "444px";
        }
    }
}

export function Text_textFormatted(text) {
    const props = [["style", {
        whiteSpace: "pre-wrap",
    }]];
    return react.createElement("span", keyValueList(props, 1), text);
}

export function Text_nobreak(text) {
    const props = [["style", {
        whiteSpace: "nowrap",
    }]];
    return react.createElement("span", keyValueList(props, 1), text);
}

export function Box_box(maxWidth, maxHeight, items) {
    let css;
    const props = [(css = append(ofArray([["width", "100%"], ["boxSizing", "border-box"]]), append(ofArray(toArray(map((arg) => ["maxWidth", toMaxWidth(arg)], maxWidth))), defaultArg(map((mh) => ofArray([["maxHeight", mh], ["overflowY", "auto"]]), maxHeight), empty()))), ["style", keyValueList(css, 1)])];
    return react.createElement("div", keyValueList(props, 1), ...items);
}

export function section(name, maxHeight, content) {
    const children_2 = [react.createElement("h3", {}, name), Box_box(void 0, maxHeight, singleton(content))];
    return react.createElement("div", {
        className: "Section",
    }, ...children_2);
}

export function Container_container(maxWidth, items) {
    const resolved = toMaxWidth(defaultArg(maxWidth, new MaxWidth(3)));
    const props = [["style", {
        width: "100%",
        ["max-width"]: resolved,
        margin: "0 auto",
        padding: "0 16px",
        ["box-sizing"]: "border-box",
    }]];
    return react.createElement("div", keyValueList(props, 1), ...items);
}

export class Paper_Variant extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Elevation", "Outlined"];
    }
}

export function Paper_Variant$reflection() {
    return union_type("FenixWeb.Gui.Paper.Variant", [], Paper_Variant, () => [[["Item", int32_type]], []]);
}

function Paper_boxShadow(_arg) {
    switch (_arg) {
        case 0: {
            return "none";
        }
        case 1: {
            return "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12)";
        }
        case 2: {
            return "0px 1px 5px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12)";
        }
        case 3: {
            return "0px 1px 8px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12)";
        }
        default: {
            return "0px 2px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)";
        }
    }
}

export function Paper_paper(variant, items) {
    let css;
    const resolved = defaultArg(variant, new Paper_Variant(0, 1));
    const props = [(css = append(ofArray([["backgroundColor", "#fff"], ["borderRadius", "4px"], ["boxSizing", "border-box"], ["padding", "16px"]]), (resolved.tag === 1) ? ofArray([["boxShadow", "none"], ["border", "1px solid rgba(0,0,0,0.12)"]]) : ofArray([["boxShadow", Paper_boxShadow(resolved.fields[0])], ["border", "none"]])), ["style", keyValueList(css, 1)])];
    return react.createElement("div", keyValueList(props, 1), ...items);
}

export class Stack_Direction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Row", "Column"];
    }
}

export function Stack_Direction$reflection() {
    return union_type("FenixWeb.Gui.Stack.Direction", [], Stack_Direction, () => [[], []]);
}

export class Stack_JustifyContent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Start", "End", "Center", "SpaceBetween", "SpaceAround", "SpaceEvenly"];
    }
}

export function Stack_JustifyContent$reflection() {
    return union_type("FenixWeb.Gui.Stack.JustifyContent", [], Stack_JustifyContent, () => [[], [], [], [], [], []]);
}

function Stack_toFlexDirection(_arg) {
    if (_arg.tag === 1) {
        return "column";
    }
    else {
        return "row";
    }
}

function Stack_toJustifyContent(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "flex-end";
        }
        case 2: {
            return "center";
        }
        case 3: {
            return "space-between";
        }
        case 4: {
            return "space-around";
        }
        case 5: {
            return "space-evenly";
        }
        default: {
            return "flex-start";
        }
    }
}

export function Stack_stack(direction, justifyContent, spacing, items) {
    let css;
    const dir = defaultArg(direction, new Stack_Direction(1));
    const justify = defaultArg(justifyContent, new Stack_JustifyContent(0));
    const props = [(css = toList(delay(() => append_1(singleton_1(new CSSProp(125, "flex")), delay(() => append_1(singleton_1(new CSSProp(136, Stack_toFlexDirection(dir))), delay(() => append_1(singleton_1(new CSSProp(200, Stack_toJustifyContent(justify))), delay(() => {
        const matchValue = spacing;
        let pattern_matching_result, px_1;
        if (matchValue != null) {
            if (matchValue > 0) {
                pattern_matching_result = 0;
                px_1 = matchValue;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return singleton_1(["gap", `${(px_1 * 8)}px`]);
            }
            case 1: {
                return empty_1();
            }
        }
    })))))))), ["style", keyValueList(css, 1)])];
    return react.createElement("div", keyValueList(props, 1), ...items);
}

export function Stack_rowSpaced(spacing, items) {
    return Stack_stack(new Stack_Direction(0), void 0, spacing, items);
}

export function Stack_columnSpaced(spacing, items) {
    return Stack_stack(new Stack_Direction(1), void 0, spacing, items);
}

export function Table_tableWithPane(id, getId, columns, view, items) {
    return FunctionComponent_Of_Z5A158BBF(() => {
        const activeState = react.useState(void 0);
        if (isEmpty(items)) {
            return info("Empty".split(""));
        }
        else {
            const headers = map_1((tupledArg) => Elements_renderHeader(tupledArg[0]), columns);
            const activeItem = bind((selectedId) => tryFind((item) => (getId(item) === selectedId), items), activeState[0]);
            const rows = map_1((item_1) => {
                const rowId = getId(item_1);
                const props = [new Prop(0, rowId), new HTMLAttr(65, equals(activeState[0], rowId) ? "is-active" : ""), new DOMAttr(40, (_arg_1) => {
                    activeState[1]((_arg_2) => rowId);
                })];
                const children = map_1((tupledArg_1) => Elements_renderCell(tupledArg_1[1](item_1)), columns);
                return react.createElement("tr", keyValueList(props, 1), ...children);
            }, items);
            const children_18 = toList(delay(() => {
                let children_10, children_8, children_4;
                return append_1(singleton_1((children_10 = [(children_8 = [(children_4 = [react.createElement("tr", {}, ...headers)], react.createElement("thead", {}, ...children_4)), react.createElement("tbody", {}, ...rows)], react.createElement("table", {
                    className: "pro-table",
                }, ...children_8))], react.createElement("div", {
                    className: "table-with-pane__table",
                }, ...children_10))), delay(() => {
                    let children_16, children_12;
                    const matchValue = activeItem;
                    return (matchValue == null) ? singleton_1((children_16 = [react.createElement("span", {})], react.createElement("div", {
                        className: "table-with-pane__view",
                    }, ...children_16))) : singleton_1((children_12 = [view(value_1(matchValue))], react.createElement("div", {
                        className: "table-with-pane__view",
                    }, ...children_12)));
                }));
            }));
            return react.createElement("div", {
                id: id,
                className: "table-with-pane",
            }, ...children_18);
        }
    }, "TableWithPane", uncurry(2, void 0), void 0, "tableWithPane", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Gui.fs", 129)();
}

export function Table_table(id, columns, items) {
    let children_4;
    if (isEmpty(items)) {
        return info("Empty".split(""));
    }
    else {
        const headers = map_1((tupledArg) => Elements_renderHeader(tupledArg[0]), columns);
        const rows = map_1((x) => {
            const children = map_1((tupledArg_1) => Elements_renderCell(tupledArg_1[1](x)), columns);
            return react.createElement("tr", {}, ...children);
        }, items);
        const children_8 = [(children_4 = [react.createElement("tr", {}, ...headers)], react.createElement("thead", {}, ...children_4)), react.createElement("tbody", {}, ...rows)];
        return react.createElement("table", {
            className: "pro-table",
        }, ...children_8);
    }
}

